export const Thumbnail = ({
  src,
  file,
  onClick,
  picked,
  highlight,
  rotate,
}: {
  src: string;
  file: FileSystemFileHandle | undefined;
  onClick: () => void;
  picked: boolean;
  highlight: boolean;
  rotate: string;
}) => (
  <figure
    onClick={onClick}
    style={{
      margin: 0,
      cursor: 'zoom-in',
      border: highlight
        ? `2px solid var(--ls-accent)`     /* プレビュー中 */
        : picked
        ? `2px solid var(--ls-primary)`    /* 選択済み */
        : `1px solid var(--ls-border)`,    /* デフォルト */
      borderRadius: 4,                    /* ↖ 0 にすれば角丸ゼロ */
      background: 'var(--ls-surface)',
    }}
  >
    <img
      src={src}
      alt={file?.name ?? ''}
      style={{
        width: '100%',
        height: 200,
        objectFit: 'contain',
        display: 'block',
        userSelect: 'none',
        transform: rotate,
      }}
      loading="lazy"
    />
    <figcaption
      style={{
        fontSize: 12,
        padding: '2px 4px',
        color: 'var(--ls-muted)',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }}
      title={file?.name ?? ''}
    >
      {file?.name ?? ''}
    </figcaption>
  </figure>
);
